import React from 'react';
import '../styles/App.css';
import '../styles/Table.css'
import {api} from "../api/v1/api";
import {trackPromise} from "react-promise-tracker";

/**
 * Class used to render Question and Answers for GSPAS Vins
 *
 * @author Ethan Jones
 */
class GspasQuestionAnswerTable extends React.Component{
    serverApi;

    /**
     * Constructor for GspasQuestionAnswerTable. Sets the questiona dnad answer map to be worked on. Instantiates a
     * new api object
     * @param props props
     */
    constructor(props) {
        super(props);

        this.state.questionAnswerMap = this.props.QuestionAnswer
        this.state.questionAnswerMap.map((qaCategory, index) =>{
            this.state.questionsList.push(qaCategory)
        })
        this.state.questionRenderList.push(this.state.questionsList[0])
        this.serverApi = new api()
        this.state.initialRender = this.props.initialRender
    }
    state={
        questionsList: [],
        questionRenderList:[],
        questionsIndexSelection:[],
        questionAnswerMap: null,
        initialRender: true,
        stopRender: false,
    }

    /**
     * Method used for handling when user selects an answer to a GSPAS Question and Answer
     *
     * @param questionAnswerMap QuestionAndAnswerMap
     * @param selection Selected answer
     * @param questionIndex Index in mp where question is
     * @param answerIndex   index for selected answer
     * @returns {Promise<void>}
     */
    async handleQuestionAnswerSelection(questionAnswerMap, selection, questionIndex, answerIndex){

        questionAnswerMap[1] = await selection
        this.state.questionAnswerMap[questionIndex] = await questionAnswerMap
        this.state.questionsIndexSelection.push(answerIndex)
        if((questionIndex + 1) !== this.state.questionsList.length) {
            this.state.questionRenderList.push(this.state.questionsList[questionIndex + 1])
        }

        await this.props.qaHandler(questionIndex, questionAnswerMap)
    }

    /**
     * Initially method to set necessary amount of answer before sending the data back to the Sps2Info Backend
     * @returns {Promise<void>}
     */
    async setInitialRender(){
        await this.props.initHandler(this.props.QuestionAnswer.length, false)
        await this.setState({
            initialRender: false,
        })
    }

    /**
     * Method for rendering the Gspas Question and Answers.
     * @returns {*[]}
     */
    renderGspasQuestionAnswerTable(){
        return(
            this.state.questionRenderList && this.state.questionRenderList.map((data, index) =>(
                    <div>
                        <label className={"GspasQATableLabel"}>{data[0].category}</label>
                        <div className={"GspasQATable"}>
                        <table>
                            {data[0].options.map((answer, answerIndex)=>(
                                <tr onClick={()=> this.handleQuestionAnswerSelection(data, answer, index,answerIndex)}>
                                    <td className={this.state.questionsIndexSelection[index] === answerIndex ? "selectedRow" : ""}>
                                        {answer.description}
                                    </td>
                                </tr>
                            ))}
                        </table>
                        </div>
                    </div>
                ))

        )
    }

    /**
     * After all questions have been answered, this method makes use of the api to send the Calibration Data along
     * with the answered questions to get the updated Calibration Data
     *
     * @returns {Promise<void>}
     */
    async getGspasQACalData(){

        if(this.props.qaCounter === this.props.qaLimit){
            await this.setState({stopRender: true})
            await trackPromise(this.serverApi.getGspasQACalData(this.props.progSeqData, this.props.calDataHandler,
                this.props.errorHandler))
        }
    }

    /**
     * Main render method of GspasQA Table
     * @returns {*[]|*}
     */
    render(){

        if(!this.state.stopRender){
            this.getGspasQACalData()
        }
        if(this.props.qaInitialRender){
            this.setInitialRender()
            return(<div></div>)
        }else{
            return(this.renderGspasQuestionAnswerTable())
        }
    }
}

export default GspasQuestionAnswerTable;